import http from '../../../axios'

export let get_withdrawal_record = (params = '') =>
  http.post('/withdrawal/get-withdrawal-record', params)

export let get_withdrawal = (params = '') =>
  http.post('/withdrawal/get-withdrawal', params)

export let add_bank_info = (params = '', direct = '') =>
  http.post('/withdrawal/add-bank-info', params, { direct })

export let submit_withdrawal = (params = '', direct = '') =>
  http.post('/withdrawal/submit-withdrawal', params, { direct })
